import {observer} from "mobx-react-lite";
import React, {useState} from "react";
import SyncOrdersApi from "../../api/SyncOrdersApi";
import ReactJson from "react-json-view";

export const OrdersDebugPage = observer(() => {
    const [orders, setOrders] = useState<any[]>([])
    const [customOrder, setOrder] = useState<string>("");
    return <>
        <h1>
            Тест заказов
        </h1>
        <div>
            Код произвольного заказа(json):
            <textarea value={customOrder} onChange={({target}) => setOrder(target.value)}/>
        </div>
        <div className={"custom-my-12"}>
            <button
                onClick={() => {
                    SyncOrdersApi.importCustomOrder(customOrder);
                }}
            >Импортировать произвольный заказ
            </button>
        </div>
        <div className={"custom-my-12"}>
            <button
                onClick={() => {
                    SyncOrdersApi.getOrdersAsList().then((result) => {
                        setOrders(result.data.data)
                    })
                }}
            >Получить заказы
            </button>
        </div>


        <div>
            {orders.map((order, index) =>
                <div key={index} className={'custom-my-24'}>
                    <div>
                        Заказ {order.order_id}:
                        <button onClick={() => {
                            SyncOrdersApi.importOneDebugOrder(order.order_id)
                        }}>
                            Импортировать заказ
                        </button>
                    </div>
                    <div>
                        <ReactJson src={order}
                                   name={false}
                                   displayDataTypes={false}
                                   collapsed={true}
                        />
                    </div>

                </div>
            )}
        </div>
    </>
})